import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import EventTypesSection from './components/EventTypesSection';
import FullBandsSection from './components/FullBandsSection';
import FeaturedArtistsSection from './components/FeaturedArtistsSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <CategoriesSection />
        <EventTypesSection />
        <FullBandsSection />
        <FeaturedArtistsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}